import React from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import dayjs from '../../../../lib/dayjsExtended';
import { DATE_TIME_FORMAT } from '../../../../const/system';
import EmptyReleasedTo from '../../../../components/EmptyReleasedTo';



const ReleasedToDetailsItem = ({ releasedTo, isPublished }) => {
  return !isEmpty(releasedTo)
    ? dayjs(releasedTo).utc().format(DATE_TIME_FORMAT)
    : <EmptyReleasedTo isPublished={isPublished} />;
};

ReleasedToDetailsItem.propTypes = {
  isPublished: PropTypes.bool,
  releasedTo: PropTypes.string,
};

export default ReleasedToDetailsItem;
